import Dexie from 'dexie';

export const db = new Dexie('NexusPOS_Offline');

db.version(1).stores({
  products: 'id, name, sku, categoryId',
  outbox: 'id, createdAt', // Pending sales
  metadata: 'key' // Last sync times, etc.
});

// Helper to save products for offline search
export const saveProductsOffline = async (products) => {
  await db.products.clear();
  await db.products.bulkAdd(products);
};

// Helper to add sale to outbox
export const queueSaleOffline = async (saleData) => {
  await db.outbox.add({
    ...saleData,
    id: saleData.id || crypto.randomUUID(),
    createdAt: new Date().toISOString(),
    isOffline: true
  });
};

// Helper to get pending sales
export const getPendingSales = async () => {
  return await db.outbox.toArray();
};

// Helper to remove synced sale
export const markSaleSynced = async (id) => {
  await db.outbox.delete(id);
};
